export function isNumeric(n: string) {
    const value = parseFloat(n);
    return !isNaN(value) && isFinite(value);
};